import React, { useState } from "react";

const SoftwareExperience = ({
  selectedSoftwareLogos,
  setSelectedSoftwareLogos,
}) => {
  const [toastMessage, setToastMessage] = useState("");

  const images = [
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/3ds+Max.png",
      icon: "3ds+Max",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/After+Effect.png",
      icon: "After+Effect",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Archicad.png",
      icon: "Archicad",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Autocad.png",
      icon: "Autocad",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/D5.png",
      icon: "D5",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Dynamo.png",
      icon: "Dynamo",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Enscape.png",
      icon: "Enscape",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Grasshopper.png",
      icon: "Grasshopper",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Indesign.png",
      icon: "Indesign",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Lumion.png",
      icon: "Lumion",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Photoshop.png",
      icon: "Photoshop",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Premier.png",
      icon: "Premier",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Revit.png",
      icon: "Revit",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Rhino.png",
      icon: "Rhino",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/SketchUp.png",
      icon: "SketchUp",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Twinmotion.png",
      icon: "Twinmotion",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Unreal.png",
      icon: "Unreal",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/V-Ray.png",
      icon: "V-Ray",
    },
    {
      name: "https://cass-files.s3.us-east-2.amazonaws.com/Vectorworks.png",
      icon: "Vectorworks",
    },
  ];

  const toggleImageSelection = (imageName) => {
    if (
      selectedSoftwareLogos.length >= 6 &&
      !selectedSoftwareLogos.includes(imageName)
    ) {
      setToastMessage("Maximum 6 images allowed.");
      return;
    }

    const index = selectedSoftwareLogos.indexOf(imageName);
    if (index === -1) {
      setSelectedSoftwareLogos([...selectedSoftwareLogos, imageName]);
    } else {
      const updatedSelectedImages = [...selectedSoftwareLogos];
      updatedSelectedImages.splice(index, 1);
      setSelectedSoftwareLogos(updatedSelectedImages);
    }
    setToastMessage("");
  };

  return (
    <>
      <div className="mt-5">
        <h1 className="text-md font-semibold ">SOFTWARE EXPERIENCE</h1>
        <label
          htmlFor="password"
          className="block mt-2 text-sm font-medium leading-6 text-gray-500"
        >
          Select Software Experience (Max 6){" "}
          <span className="text-red-500">*</span>
        </label>
        <div className="flex flex-wrap gap-3 justify-center mt-10">
          {images.map((image, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center">
                <img
                  src={image.name}
                  alt={image.icon}
                  className={`m-2 w-28 cursor-pointer ${
                    selectedSoftwareLogos.includes(image.name)
                      ? ""
                      : "filter grayscale"
                  }`}
                  onClick={() => toggleImageSelection(image.name)}
                />
                <span>{image.icon}</span>
              </div>
              {selectedSoftwareLogos.includes(image.name) && (
                <div className="absolute top-0 right-0 bg-green-500 text-white rounded-full p-1">
                  ✓
                </div>
              )}
            </div>
          ))}
        </div>
        {toastMessage && (
          <div className="text-red-500 mt-2">{toastMessage}</div>
        )}
      </div>
    </>
  );
};

export default SoftwareExperience;
